import React from 'react';
import { GenericSelect, GenericOption } from 'com-gyf-webcore-userinterfacecomponents';
import DefinicionEstados from './DefinicionEstados';
import EdicionEstados from './EdicionEstados';
import ConfiguracionInicial from './ConfiguracionInicial';

const CrearCircuitoEstados = ({ data, plasticos, cambiarCombo, inicioCreacion, asignarNombreEstado, siguenteEstado, asignarDocumentacionAEstado, actualizarCantidadEstadosSalida, asignarEstadoDeSalida, cancelarEdicion, finalizarCreacion }) => {

    if (data.loading)
        return <p>Cargando....</p>;

    if (data !== undefined && data.functions !== undefined) {

        //Selecciono la pantalla que se va a mostrar a la derecha...
        let pantalla = null;
        if (data.creandoCircuito) {
            if (data.estadoActual === 0) {
                pantalla = < DefinicionEstados data={data} asignarNombreEstado={asignarNombreEstado} siguenteEstado={siguenteEstado} cancelarEdicion={cancelarEdicion} />;
            } else if (data.estadoActual > 0) {
                pantalla = < EdicionEstados data={data} siguenteEstado={siguenteEstado} asignarDocumentacionAEstado={asignarDocumentacionAEstado} actualizarCantidadEstadosSalida={actualizarCantidadEstadosSalida} asignarEstadoDeSalida={asignarEstadoDeSalida} finalizarCreacion={finalizarCreacion} />;
            }
        } else {
            pantalla = < ConfiguracionInicial data={data} inicioCreacion={inicioCreacion} cambiarCombo={cambiarCombo} />;
        }

        return (
            <div>
                {pantalla}
            </div>
        );
    } else {
        return null;
    }
}

export default CrearCircuitoEstados;
